import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction"; // Required for click events
import moment from "moment";

const AttendanceCalendar = () => {
    const [events, setEvents] = useState([]);
    const [currentYear, setCurrentYear] = useState(moment().year());
    const [currentMonth, setCurrentMonth] = useState(moment().month() + 1);
    // const month = moment().format("MM");
    // const year = moment().format("YYYY");


    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem("key"));
    useEffect(() => {
        const fetchAttendance = async () => {

            const mockData = {}
            const response = await fetch(
                SERVER_URL + `api/reports/getuserlogincountinmontheachday`,
                {
                    method: "post",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        authorization: `bearer ${token.value}`,
                    },
                    body: JSON.stringify({
                        month: currentMonth,
                        year: currentYear,
                    }),
                }
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const result = await response.json();
            if (result.status == true) {

                result.results.map((item, ind) => {
                    // console.log('item=>', item)
                    mockData[item.att_date] = item.login_count;

                })
            }
            // console.log('result=>', mockData)


            // Mock data (Replace with actual API response)
            // const mockData = {
            //     "2025-03-01": 5,
            //     "2025-03-03": 2,
            //     "2025-03-05": 8,
            //     "2025-03-10": 3,
            // };

            const formattedEvents = Object.keys(mockData).map((date) => ({
                // title: `User Count: ${mockData[date]}`,
                title: `${mockData[date]}`,
                start: date,
                allDay: true, // Ensure full-day events work properly
                extendedProps: { count: mockData[date] }, // Additional event properties
            }));

            setEvents(formattedEvents);
        };

        fetchAttendance();
    }, [currentMonth, currentYear]);

    // Handle event click
    // const handleEventClick = (info) => {
    //     const date = moment(info.event.start).format("YYYY-MM-DD");
    //     const count = info.event.extendedProps.count;

    //     alert(`Attendance on ${date}: ${count} records`);
    // };
    const handleDatesSet = (arg) => {
        const newYear = moment(arg.view.currentStart).year(); // Get displayed year
        const newMonth = moment(arg.view.currentStart).format("MM");
        setCurrentYear(newYear);
        setCurrentMonth(newMonth);
    }
    return (
        <div>
            <div className="dash_white_box_ttl">Tracker</div>
            <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]} // Ensure interactionPlugin is added
                initialView="dayGridMonth"
                events={events}
                height="auto"
                firstDay={1}
                // eventClick={handleEventClick} // Handles event click
                datesSet={handleDatesSet} // Detects previous/next month clicks
                eventContent={(arg) => {
                    return {
                        html: `<i class="fa fa-user"></i> <span>${arg.event.title}</span>`,
                    };
                }}
            />
        </div>
    );
};

export default AttendanceCalendar;
